import style from "./PasswordSuccess.module.css";
import { useNavigate } from "react-router-dom";
import { resetpasswordUpdate } from "../../stores/slices/updatePasswordSlice";  
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
const PassswordSuccess = () => {
  const selectedLanguage = useSelector(language).passwordSuccess;
    let  dispatch= useDispatch()
    let navigate = useNavigate()
    const backtoLogin = () =>{
        dispatch(resetpasswordUpdate())
        navigate('/')
    }
  return (
    <>

      <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className={`${style.basic_page}`}>
              <div className={style.tick}>✔</div>
          <div className="container pt-3">
            <p className={style.success}>
            {selectedLanguage?.passwordUpdateSuccessfully}
            </p>
            <p className="pt-3">
            {selectedLanguage?.yourPasswordUpdate}
            </p>
            <p onClick={backtoLogin} className={`p-3 mr-5 ${style.reg_link}`}>
            <u> {selectedLanguage?.backToLogin}</u>
          </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PassswordSuccess;
